import { v4 as uuid } from '@lukeed/uuid'
import { get } from 'svelte/store'

import { makeTax } from '$lib/factories'
import { messages } from '$lib/messages'
import { apiPostJson } from '$lib/proxy/apiProxy'
import { debounced, SemaphoreKey } from '$lib/semaphores'
import type { Tax, TaxProps } from '$lib/types/client_types'
import { CustomErrorMgr } from '$lib/types/custom_error'

import { accTaxes_store } from './taxes'


export const UpsertAccTax = async (tax: TaxProps) => {
	tax.id = tax.id || uuid()

	if (tax.name === '' || tax.name?.trim() === '') return

	_upsertAccTaxes(tax)

	const fnSave = saveAccTax(tax)
	return await debounced(SemaphoreKey.Tax, fnSave, 0)
}


export async function DeleteAccTax(id: string) {
	const jsonData = await apiPostJson('/taxes/delete', { id: id })

	if (CustomErrorMgr.HasErrorInfo(jsonData.error)) {
		if (CustomErrorMgr.IsWarning(jsonData.error)) {
			messages.warning(jsonData.error.message)
		} else {
			messages.error(jsonData.error.message)
		}
		return
	}

	_deleteAccTax(id)
}

export const getAccTax = (taxId: string) => {
	const taxes = get(accTaxes_store)
	return taxes.find((st) => st.id === taxId)
}

export async function getTaxes(TaxesParams: any) {
	// TODO: get data from the store
	const parameters = TaxesParams
	const jsonData = await apiPostJson('/taxes', {
		archived: parameters.archived,
		query: parameters.query,
		withName: parameters.withName,
		tax_id: parameters.taxId
	})
	if (jsonData?.error) {
		return
	}
	return jsonData.taxes
}

export function formatTaxListItemText(item: Tax) {
	if (!item) return ''

	if (item.id == 'new-item') return item.name

	return item.name + ' - (' + item.rate + '%)'
}


// Actions =======================================
function saveAccTax(tax: Record<string, unknown>) {

	// if (typeof tax.name === 'string') {
	// 	tax.name = tax.name.trim()
	// }

	const saveFn = async () => {
		console.log('saveDebounce - tax:', tax)
		const jsonData = await apiPostJson('/taxes/upsert', { tax })
		if (jsonData?.error) {
			throw `Could not save tax: ${jsonData.error.message}`
		}
	}

	return saveFn
}

function _upsertAccTaxes(updates: TaxProps) {
	let t = makeTax()
	t = { ...t, ...updates }

	const taxes = get(accTaxes_store)
	const i = taxes.findIndex((e) => e.id === t.id)

	if (i >= 0) 
		taxes[i] = { ...taxes[i], ...t }
	else 
		taxes.push(t)

	accTaxes_store.set(taxes)
}

function _deleteAccTax(id: string) {
	const taxes = get(accTaxes_store).filter(function (tax) {
		return tax.id != id
	})

	accTaxes_store.set(taxes)
}

